<script setup lang="ts"></script>

<template>
  <div class="top-wr" style="height: 350px">
    <div class="home">
      <h2 class="main-title" style="margin-top: 60px;">Партнерам</h2>
      <div style="font-size: 14px; color: white; text-align: center">
        <a href="/">Главная</a>
        &gt; Партнерам
      </div>
    </div>
  </div>
  <div
      style="
      height: 100%;
      text-align: left;
      padding-top: 50px;
      padding-bottom: 30px;
      width: 1040px;
      margin-left: auto;
      margin-right: auto;
    "
      class="about-media"
  >
    <div>
      В сотрудничестве мы придерживаемся равноправных принципов 50/50.
    </div>
  </div>
</template>

<style scoped>
.home{
  background-image: url(../../../assets/image/lg2.jpg) !important;
  height: 370px;
  margin-top: -131px;
  background-position-y: -650px;
  background-position-x: 0px;
  background-size: cover;

  font-size: 36px;
  font-family: 'Gilroy', sans-serif;
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 500;
}
</style>
